import { useState, useEffect } from 'react';
import useAuthStore from '@/store/Auth';
import useEnumsStore from '@/store/Enums';
import WebAppService from '@/services/WebAppService';

export default function useDashboardInit(isMobile: boolean) {
  const { isAuthenticated, user, updateUser, updateOrganization } =
    useAuthStore();
  const { fetchAllEnums } = useEnumsStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (isAuthenticated && !isMobile) {
        try {
          const [userResponse, orgResponse] = await Promise.all([
            WebAppService.getCurrentUser(user?.id),
            WebAppService.getOrganizationById(user?.organization as string),
          ]);

          if (userResponse?.data) updateUser(userResponse.data);
          if (orgResponse) updateOrganization(orgResponse);

          fetchAllEnums();
        } catch (error) {
          console.error('Error initializing dashboard:', error);
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [isAuthenticated, isMobile]);

  return { loading };
}
